export function scaleMultiplier() {
    const scaleElements = document.querySelectorAll('[data-scale-multiplier]');
    scaleElements.forEach((el) => {
        const defaultWidth = el.getAttribute('data-scale-multiplier');
        if (!!defaultWidth === false) return;
        const defaultWidthNumber = parseFloat(defaultWidth);
        updateProperty();
        let timeout;
        new ResizeObserver(() => {
            clearTimeout(timeout);
            timeout = setTimeout(updateProperty, 10);
        }).observe(el);
        function updateProperty() {
            el.style.setProperty('--scaleMultiplier', el.clientWidth / defaultWidthNumber);
        }
    });
}
